import React from 'react';
import FilterIcon from './FilterIcon';

const FilterButton = ({ callback, isActive, text, color='' }) => {
    let classes = "hoverable border-on-hover text-nowrap my-1 p-1 px-2 sc-glass rounded";
    if(color) classes += ` ${color}`
    return (
        <span className={classes} onClick={callback}>
            {isActive && <FilterIcon />}
            {text}
        </span>
    );
};

export default FilterButton;
